import React from 'react';
import PropTypes from 'prop-types';
import { Pagination, Row, Col } from 'react-bootstrap';
import { filter, map } from 'lodash';

const isCurrentPageEmpty = (totalCount, itemsPerPage, currentPage) => {
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  return (
    (totalCount && totalCount > itemsPerPage && currentPage > totalPages) ||
    ((!totalCount || totalCount <= itemsPerPage) && currentPage > 1)
  );
};

const TablePagination = ({
  currentPage,
  isPaginationOn,
  itemsPerPage,
  stretchView,
  totalCount,
  changePage
}) => {
  if (!isPaginationOn) return '';
  if (totalCount && totalCount > itemsPerPage) {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const pagesToGenerate = map(Array(totalPages), (n, i) => i + 1);
    const pagesToShow = filter(
      pagesToGenerate,
      pagenumber => Math.abs(pagenumber - currentPage) <= 2
    );
    let tempCurrentPage = currentPage;
    if (isCurrentPageEmpty(totalCount, itemsPerPage, currentPage)) {
      while (isCurrentPageEmpty(totalCount, itemsPerPage, tempCurrentPage)) tempCurrentPage -= 1;
      changePage(tempCurrentPage);
    }
    return (
      <Row>
        <Col className="d-flex justify-content-end">
          <Pagination className="my-1">
            {!stretchView && (
              <Pagination.First
                className="hide-md"
                onClick={() => changePage(1)}
                onKeyDown={() => changePage(1)}
              />
            )}
            <Pagination.Prev
              onClick={() => {
                if (currentPage > 1) changePage(currentPage - 1);
              }}
              onKeyDown={() => {
                if (currentPage > 1) changePage(currentPage - 1);
              }}
            />
            {!stretchView &&
              map(pagesToShow, pageNumber => (
                <Pagination.Item
                  key={`pagination_${pageNumber}`}
                  className="hide-md"
                  active={pageNumber === currentPage}
                  onClick={() => changePage(pageNumber)}
                  onKeyDown={() => changePage(pageNumber)}
                >
                  {pageNumber}
                </Pagination.Item>
              ))}
            <Pagination.Next
              onClick={() => {
                if (currentPage < totalPages) changePage(currentPage + 1);
              }}
              onKeyDown={() => {
                if (currentPage < totalPages) changePage(currentPage + 1);
              }}
            />
            {!stretchView && (
              <Pagination.Last
                className="hide-md"
                onClick={() => changePage(totalPages)}
                onKeyDown={() => changePage(totalPages)}
              />
            )}
          </Pagination>
        </Col>
      </Row>
    );
  }
  if (currentPage !== 1) changePage(1);
  return '';
};

TablePagination.defaultProps = {
  currentPage: 1,
  itemsPerPage: 1,
  stretchView: false,
  totalCount: 0,
  changePage: () => {}
};

TablePagination.propTypes = {
  currentPage: PropTypes.number,
  isPaginationOn: PropTypes.bool.isRequired,
  itemsPerPage: PropTypes.number,
  stretchView: PropTypes.bool,
  totalCount: PropTypes.number,
  changePage: PropTypes.func
};

export default TablePagination;
